import React, { useCallback, useMemo } from 'react';
import ScalarSpreadsheet from 'components/ScalarSpreadsheet';
import { SecuritySharesTableConfig } from './types';

const SecuritySharesTable = ({
  spreadsheet,
  onChange,
  workbook,
  setIsDisplayingRowNumbers,
  format,
  formatDispatch,
}: SecuritySharesTableConfig) => {
  const perShareFormat = useMemo(
    () => (format ? { ...format, currency: { ...format.currency, units: '' } } : format),
    [format]
  );

  const perShareFormatDispatch = useCallback(
    (action: any) => {
      if (action?.currency?.units !== undefined) {
        const { units: _stripped, ...currencyWithoutUnits } = action.currency;
        formatDispatch?.({ ...action, currency: currencyWithoutUnits });
      } else {
        formatDispatch?.(action);
      }
    },
    [formatDispatch]
  );

  const tableKey = 'security-shares-table';

  return (
    <ScalarSpreadsheet
      {...spreadsheet}
      id={tableKey}
      tableTerms={{
        tableSlug: tableKey,
      }}
      onChange={onChange}
      sheet={spreadsheet}
      workbook={workbook}
      format={perShareFormat}
      formatDispatch={perShareFormatDispatch}
      setIsDisplayingRowNumbers={setIsDisplayingRowNumbers}
      disableVerticalScroll
      isLedgerTable
      isToolbarVisible
    />
  );
};

export default SecuritySharesTable;
